/**
 * Shared graded-card reveal transition IDs and slab wipe angles.
 * Used by Card.vue (GLTF slab); LIGHTS_DOWN_WIPE_ANGLE is shared with CardRaw chase/grail timelines.
 */
export const TRANSITIONS_REVEAL = {
    SPIN: 'spin',
    ZOOM: 'zoom',
    TILT: 'tilt',
    WIGGLE: 'wiggle',
    BURN: 'burn',
} as const;

export const BASE_WIPE_ANGLE = 110;
export const HIGH_TIER_WIPE_ANGLE = 90;
export const LIGHTS_DOWN_WIPE_ANGLE = 275;
